import BaseCommand from "@/models/api/commands/BaseCommand";

export class ToggleCreateVoucherCommand extends BaseCommand {
  CommandName = "ToggleCreateVoucher";
  Command: {
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId };
  }
}
